import { render, staticRenderFns } from "./IPTUclientes.vue?vue&type=template&id=d75f35e0&scoped=true&"
import script from "./IPTUclientes.vue?vue&type=script&lang=js&"
export * from "./IPTUclientes.vue?vue&type=script&lang=js&"
import style0 from "./IPTUclientes.vue?vue&type=style&index=0&id=d75f35e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75f35e0",
  null
  
)

export default component.exports